var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"u-button",class:_vm.getClass(),attrs:{"disabled":_vm.disabled},on:{"click":_vm.uClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }